import React, { Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import {
  withStyles,
  Grid,
  DialogActions,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  FormHelperText,
} from '@material-ui/core';
import Swal from 'sweetalert2';
import './styles/dialog.css';
import { withTranslation } from 'react-i18next';

class ContactPerson extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        id: null,
        firstname: '',
        lastname: '',
        phone: '',
        relationship: '',
        imgProfileUrl: null,
        isValid: true,
      },
    };
  }

  onTextChange = (key, value) => {
    this.props.contactperson.changeData(key, value);
  };

  handleSubmit = async () => {
    const { patient, t } = this.props;
    const { contactDatas } = this.props.contactperson.toJS();

    const valid = this.validate();
    if (valid) {
      const data = contactDatas.filter(
        (contact) =>
          contact.firstname.length > 0 &&
          contact.lastname.length > 0 &&
          contact.phone.length > 0 &&
          contact.relationship.length > 0,
      );
      try {
        await this.props.contactperson.updateCurrentContact(patient.id, data);
        this.props.handleClose();
      } catch (error) {
        Swal.fire({
          html: `<h4>${t('failed_to_update')}`,
          confirmButtonText: `${t('ok')}`,
          type: 'warning',
          customClass: {
            container: 'my-swal',
          },
        });
      }
    }

    // const { data, contactPersons } = this.props.contactperson.toJS();
    // if (contactPersons.length > 0) {
    //   this.handleUpdate(data);
    // } else {
    //   this.handleCreate(data, patient.id);
    // }
  };

  handleCreate = async (data, patientId) => {
    const { t } = this.props;
    try {
      await this.props.contactperson.create(data, patientId);
      this.props.handleClose();
    } catch (error) {
      Swal.fire({
        html: `<h4>${t('failed_to_create')}`,
        confirmButtonText: `${t('ok')}`,
        type: 'warning',
        // width: 400,
        customClass: {
          container: 'my-swal',
        },
      });
    }
  };

  handleUpdate = async (data) => {
    const { t } = this.props;
    try {
      this.props.handleClose();
      await this.props.contactperson.update(data);
    } catch (error) {
      Swal.fire({
        html: `<h4>${t('failed_to_update')}`,
        confirmButtonText: `${t('ok')}`,
        type: 'warning',
        // width: 400,
        customClass: {
          container: 'my-swal',
        },
      });
    }
  };

  getFullname = (language, data) => {
    let fullname = '';
    if (language && language === 'th-TH') {
      if (data.firstname || data.lastname) {
        fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
      } else {
        fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
      }
    }

    if (language && language === 'en-EN') {
      if (data.firstnameEn || data.lastnameEn) {
        fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
      } else {
        fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
      }
    }

    return fullname;
  };

  addContactPerson = () => {
    let { contactDatas } = this.props.contactperson.toJS();
    contactDatas.push(this.state.data);
    this.props.contactperson.setContactPerson(contactDatas);
  };

  removeContactPerson = (index) => {
    const { contactDatas } = this.props.contactperson.toJS();
    const results = contactDatas.filter((val, i) => i !== index);
    if (results.length === 0) {
      results.push(this.state.data);
    }

    this.props.contactperson.setContactPerson(results);
  };

  handleChangeInput = (key, value, index) => {
    this.props.contactperson.changeMultiData(key, value, index);
  };

  clearErrorField(key) {
    if (key === 'hn') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          hn: false,
        },
      });
    }
    if (key === 'firstname') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          firstname: false,
        },
      });
    }
    if (key === 'lastname') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          lastname: false,
        },
      });
    }
  }

  validate() {
    const { contactDatas } = this.props.contactperson.toJS();
    // add valid data
    const results = (contactDatas || []).map((contact) => {
      if (
        contact.firstname.length === 0 &&
        contact.lastname.length === 0 &&
        contact.phone.length === 0 &&
        contact.relationship.length === 0
      ) {
        contact.isValid = true;
      } else {
        if (
          contact.firstname.length > 0 &&
          contact.lastname.length > 0 &&
          contact.phone.length > 0 &&
          contact.relationship.length > 0
        ) {
          contact.isValid = true;
        } else {
          contact.isValid = false;
        }
      }
      return contact;
    });

    this.props.contactperson.setContactPerson(results);

    const validData = results.filter((result) => result.isValid === false);
    return validData.length > 0 ? false : true;
  }

  render() {
    const { classes, state, props, t, readOnly, patient } = this.props;
    const { contactDatas } = this.props.contactperson.toJS();
    const relationshipList = ['couple', 'children', 'relative', 'other'];
    const fullname = this.getFullname(localStorage.getItem('i18nextLng'), patient);

    return (
      <Dialog
        open={state.dialogContact.open}
        onClose={this.props.handleClose}
        aria-labelledby='form-dialog-title'
        maxWidth='sm'
        fullWidth={true}
        PaperProps={{
          style: {
            maxWidth: '498px',
            borderRadius: 8,
          },
        }}
      >
        <DialogTitle id='form-dialog-title' className='header' style={{ padding: '24px 24px 10px' }}>
          <Grid container style={{ position: 'relative' }}>
            <div>
              {t('contact_info')} <span className='headerMain'>{fullname}</span>
            </div>
            <div id='closeIcon' className='closeIcon' onClick={this.props.handleClose}>
              <svg width='32' height='32' viewBox='0 0 32 32'>
                <use xlinkHref={`/images/menus-v1.svg#close`} />
              </svg>
            </div>
          </Grid>
        </DialogTitle>
        <DialogContent>
          {contactDatas.map((contact, index) => (
            <Grid container key={index} style={{ marginBottom: 10 }}>
              <hr
                className={classes.divider}
                style={{
                  border: index > 0 ? '1px solid #F4F4F4' : '1px solid #E5F9F6',
                }}
              />
              <Grid container item md={12} xs={12} alignItems='center' style={{ position: 'relative' }}>
                <div style={{ marginRight: 5 }}>
                  <svg width='24' height='24' viewBox='0 0 24 24'>
                    <use xlinkHref={`/images/menus-v1.svg#account-circle`} />
                  </svg>
                </div>
                <Typography className={classes.contactTitle}>
                  {t('contact')} {index + 1}
                </Typography>
                <div
                  id={`trashIcon-${index}`}
                  className={classes.trashIcon}
                  onClick={() => this.removeContactPerson(index)}
                >
                  <svg width='16' height='16' viewBox='0 0 16 16'>
                    <use xlinkHref={`/images/menus-v1.svg#trash`} />
                  </svg>
                </div>
              </Grid>

              <Grid item md={6} xs={12}>
                <div className={props.classes.formInput}>
                  <Fragment>
                    <TextField
                      id={`contact_first_name-${index}`}
                      label={t('first_name')}
                      value={contact.firstname || ''}
                      onChange={(e) => this.handleChangeInput('firstname', e.target.value, index)}
                      type='text'
                      fullWidth
                      inputProps={{ readOnly }}
                      required
                    />
                    <FormHelperText
                      error
                      hidden={!contact.isValid && contact.firstname.length === 0 ? false : true}
                      id='component-error-text'
                    >
                      {t('required_field')}
                    </FormHelperText>
                  </Fragment>
                </div>
              </Grid>

              <Grid item md={6} xs={12}>
                <div className={props.classes.formInput}>
                  <Fragment>
                    <TextField
                      id={`contact_last_name-${index}`}
                      label={t('last_name')}
                      value={contact.lastname || ''}
                      onChange={(e) => this.handleChangeInput('lastname', e.target.value, index)}
                      type='text'
                      fullWidth
                      inputProps={{ readOnly }}
                      required
                    />
                    <FormHelperText
                      error
                      hidden={!contact.isValid && contact.lastname.length === 0 ? false : true}
                      id='component-error-text'
                    >
                      {t('required_field')}
                    </FormHelperText>
                  </Fragment>
                </div>
              </Grid>

              <Grid item md={6} xs={12}>
                <div className={props.classes.formInput}>
                  <Fragment>
                    <TextField
                      id={`contact_tel-${index}`}
                      label={t('tel')}
                      value={contact.phone || ''}
                      onChange={(e) => this.handleChangeInput('phone', e.target.value, index)}
                      type='text'
                      inputProps={{ maxLength: 10, readOnly }}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                      }}
                      fullWidth
                      required
                    />
                    <FormHelperText
                      error
                      hidden={!contact.isValid && contact.phone.length === 0 ? false : true}
                      id='component-error-text'
                    >
                      {t('required_field')}
                    </FormHelperText>
                  </Fragment>
                </div>
              </Grid>

              <Grid item md={6} xs={12}>
                <div className={props.classes.formInput}>
                  <Fragment>
                    <TextField
                      select
                      id={`contact_relationship-${index}`}
                      label={t('relationship')}
                      value={contact.relationship || ''}
                      onChange={(e) => this.handleChangeInput('relationship', e.target.value, index)}
                      fullWidth
                      SelectProps={{
                        native: true,
                      }}
                      required
                    >
                      <option value=''></option>
                      {relationshipList.map((val) => (
                        <option key={val} value={val}>
                          {t(val)}
                        </option>
                      ))}
                    </TextField>
                    <FormHelperText
                      error
                      hidden={!contact.isValid && contact.relationship.length === 0 ? false : true}
                      id='component-error-text'
                    >
                      {t('required_field')}
                    </FormHelperText>
                  </Fragment>
                </div>
              </Grid>
            </Grid>
          ))}

          <Grid container item md={12} xs={12} alignItems='center'>
            <Button
              id='add-contact'
              color='primary'
              style={{ fontSize: 14, fontWeight: 400 }}
              onClick={() => this.addContactPerson()}
            >
              <div style={{ marginRight: 5 }}>
                <svg width='24' height='24' viewBox='0 0 24 24' style={{ fill: '#006469' }}>
                  <use xlinkHref={`/images/menus-v1.svg#add-circle`} />
                </svg>
              </div>
              {t('add_contact')}
            </Button>
          </Grid>
        </DialogContent>
        <DialogActions>
          {/* {!readOnly && <Button onClick={this.props.handleClose} color="default">
            {t('cancel')}
          </Button>}
          {!readOnly && <Button onClick={this.handleSubmit} color="primary">
            {t('save')}
          </Button>}
          {readOnly && <Button onClick={this.props.handleClose} color="primary">
            {t('close')}
          </Button>} */}
          <Grid
            container
            item
            style={{
              margin: '10px 28px',
              justifyContent: 'right',
            }}
          >
            {!readOnly && (
              <Button
                onClick={this.handleSubmit}
                color='primary'
                id='save'
                variant='contained'
                style={{
                  width: 100,
                }}
              >
                {t('save')}
              </Button>
            )}
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  divider: {
    transform: 'rotate(0deg)',
    marginBottom: '20px',
    width: '99%',
  },
  trashIcon: {
    position: 'absolute',
    right: 14,
    cursor: 'pointer',
    fill: theme.palette.primary.main,
  },
  contactTitle: {
    fontSize: 16,
  },
});

export const page = inject('dashboard', 'patient', 'contactperson')(observer(ContactPerson));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
